import { MyOrder } from '@diamond/shared/types';
import { resolvePaymentDestination } from '@diamond/sol-buyer/utils';

interface ResolveMyOrderPaymentDestinationArgs {
  data: Pick<MyOrder, 'order_meta_id' | 'payment_sub_state' | 'status'>;
  isPaymentInstructionEnabled: boolean;
  warehouse: string;
}

export const resolveMyOrderPaymentDestination = ({
  data,
  isPaymentInstructionEnabled,
  warehouse,
}: ResolveMyOrderPaymentDestinationArgs) => {
  const paymentSubState =
    isPaymentInstructionEnabled &&
    data.status === 'waiting_for_payment' &&
    data.payment_sub_state === null
      ? 'instruction'
      : data.payment_sub_state;

  return resolvePaymentDestination({
    isPaymentInstructionEnabled,
    orderMetaId: data.order_meta_id,
    paymentSubState,
    warehouse,
  });
};
